module.exports = __webpack_public_path__ + "static/media/transfer.ffe928cf.gif";